import React, { useState } from 'react'
import { useTranslation } from "react-i18next";
import { Row, Col } from "react-bootstrap"
import CTextBox from '../../../../Common/CTextBox';
import CLabel from '../../../../Common/CLabel';
import CDatePicker from '../../../../Common/CDatePicker';
import Message from '../../../../Common/Message';
import { Toggle } from '@fluentui/react/lib/Toggle';
import CTextArea from '../../../../Common/CTextArea';
import { useBoolean } from '@fluentui/react-hooks';
import List from '../../../../Templates/List';
import { OverflowSet } from '@fluentui/react/lib/OverflowSet';
import { DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { Panel, PanelType } from '@fluentui/react/lib/Panel';
import { Dialog, DialogFooter, DialogType } from '@fluentui/react/lib/Dialog';
import { updateMessage, saveMessage } from "../../../../../services/sBook/message.service"
import { useGetSectionsByBookId, useGetSectionPartyFullsByBookId } from "../../../../../hooks/services/sBook/useOfSection"
import { useAssignMessageToObject } from '../../../../../hooks/services/sBook/useOfMessage';
import { useGetDocumentListByMessage } from '../../../../../hooks/services/sBook/useOfDocument';
import { ActionButton } from '@fluentui/react/lib/Button';
import { getKeyByValue, joinWithoutDupes, visibilityButtonCirculate, visibilityButtonSave, visibilityButtonSend, visibilityButtonSendToApprove } from '../../../../../common/Helpers';
import { __DocumentTypeKeys } from '../../../../../common/Dictionaries';
import { addListDocumentByMessage, removeDocumentByMessageDocument } from '../../../../../services/sBook/document.service';
import ListPagination from '../../../../Templates/List/ListPagination';
import DocumentLinkModal from '../../MessageTree/DocumentLinkModal';
import moment from 'moment';
import { __onRenderOverflowButton, __onRenderOverflowItem } from '../../../../../common/CommonFuctions';
import { _global_buttonStyles } from '../../../../../common/ObjectStructures/Trasnversal';
import { computeReplyRecipients } from '../../../../../common/bookReplyRecipients';




function SidePanelResponse(props) {
    const { t } = useTranslation();
    

    //Parametros de entrada.
    const inputParam_BookObject = props.bookObject !== null && props.bookObject !== undefined ? props.bookObject : null;
    const inputParam_MessageObject = props.messageObject !== null && props.messageObject !== undefined ? props.messageObject : null;
    const inputParam_UserProps = props.userProps !== null && props.userProps !== undefined ? props.userProps : null;
    const inputParam_CurrentUserName = props.currentUserName !== null && props.currentUserName !== undefined ? props.currentUserName : null;
    const inputParam_IsPanelOpen = props.isPanelOpen;
    const inputParam_SetterIsPanelOpen = props.setterIsPanelOpen;
    const inputParam_SetterObjMessageList = props.setterObjMessageList !== null && props.setterObjMessageList !== undefined ? props.setterObjMessageList : null;

    const inputParam_SettFireGetMessage = props.setFireGetMessage !== null && props.setFireGetMessage !== undefined ? props.setFireGetMessage : null;

    //Parametros de componente.
    const [isDialogVisible, { setTrue: showDialog, setFalse: hideDialog }] = useBoolean(false);
    
    const [message, setMessage] = useState(null);
    const [messageType, setMessageType] = useState(null);
    const [showMessage, setShowMessage] = useState(false);

    const [itemToDelete, setItemToDelete] = useState(null);

    
    const [isModalDocumentOpen, setIsModalDocumentOpen] = useState(false);
    
    const [txtNameIsInValid, setTxtNameIsInValid] = useState(false)
    const [txtCodeIsInValid, setTxtCodeIsInValid] = useState(false)
    const [txtBodyIsInValid, setTxtBodyIsInValid] = useState(false)
    const [pickerAnswerDeadlineDateIsInValid, setPickerAnswerDeadlineDateIsInValid] = useState(false)

    const matchedSectionPartyForResponse = inputParam_MessageObject ? inputParam_UserProps.l_SectionPartyMemberHandler.find(x => x.sectionId === (inputParam_MessageObject.sectionId !== null ? inputParam_MessageObject.sectionId : null)) : undefined;

    // La respuesta llega al remitente y a los demás destinatarios del mensaje respondido, menos la parte que responde.
    const replyRecipients = inputParam_MessageObject ? computeReplyRecipients({
        sender: { sectionPartyId: inputParam_MessageObject.sectionPartySenderId, name: inputParam_MessageObject.sendedPartyName },
        recipients: (inputParam_MessageObject.l_partys_to ?? []).map(p => ({ sectionPartyId: p.sectionPartyId, name: p.partyName })),
        replierSectionPartyId: matchedSectionPartyForResponse?.sectionPartyId
    }) : [];

    const aux_messageObject = inputParam_MessageObject && {
        id: null,
        book_id: inputParam_BookObject.id,
        section_id: inputParam_MessageObject && inputParam_MessageObject.sectionId,
        section_party_member_id: inputParam_UserProps.username !== null && inputParam_MessageObject.id !== null ? (matchedSectionPartyForResponse !== undefined ? matchedSectionPartyForResponse.sectionPartyMemberId : null) : null,
        section_party_from_id: inputParam_UserProps.username !== null && inputParam_MessageObject.id !== null ? (matchedSectionPartyForResponse !== undefined ? matchedSectionPartyForResponse.sectionPartyId : null) : null,
        item_message: {
            id: null,
            sectionId: inputParam_MessageObject && inputParam_MessageObject.sectionId,
            messageNemo: "",
            messageCode: " ",
            correlative: 0,
            title: "",
            body: "",
            topicId: 1,
            senderUsername: inputParam_CurrentUserName,
            sectionPartySenderId: inputParam_UserProps.username !== null && inputParam_MessageObject.id !== null ? (matchedSectionPartyForResponse !== undefined ? matchedSectionPartyForResponse.sectionPartyId : null) : null,
            sendDate: moment(Date.now()).format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
            answerNeeded: false,
            answerToMessage: true,
            answerMessageNemo: inputParam_MessageObject && inputParam_MessageObject.messageNemo,
            answerMessageId: inputParam_MessageObject && inputParam_MessageObject.id,
            answerDeadlineDate: null,
            attacheds: null,
            deactivate: false,
            /// <summary>
            /// 1 en preparación
            /// 2 en circulacion
            /// 3 en aprobacion
            /// 4 enviada        
            /// </summary>
            statusId: null,
        },
        l_section_party_to_ids: replyRecipients.map(r => r.sectionPartyId)
    };
    const [objMensaje, setObjMensaje] = useState(null);
    useAssignMessageToObject(objMensaje, aux_messageObject, setObjMensaje, inputParam_IsPanelOpen);
    
    const documentUploadDisabled = objMensaje && objMensaje.item_message.id === null;

    const [fireEvent, setFireEvent] = useState(false);

    const [sectionList, setSectionList] = useState(null);
    useGetSectionsByBookId(inputParam_BookObject.id, sectionList, setSectionList, null, true, false, [], inputParam_IsPanelOpen);
    
    const [sectionPartyList, setSectionPartyList] = useState(null);
    useGetSectionPartyFullsByBookId(inputParam_BookObject.id, objMensaje && objMensaje.section_id, sectionPartyList, setSectionPartyList, null, fireEvent, setFireEvent, true);

    const [dataFilled, setDataFilled] = useState(false);
    const [documentMessageList, setDocumentMessageList] = useState({fireUpdate: true, data: null, pageNumber: 1, pageSize: 10, filters: []});
    useGetDocumentListByMessage(objMensaje && objMensaje.item_message.id, documentMessageList, setDocumentMessageList, inputParam_IsPanelOpen, dataFilled, setDataFilled)

    const [hideActionButtons, setHideActionButtons] = useState(false);

    //Funciones de componente.

    //Eventos de componente.
    const isInValidFormControl = () => {
        let isInvalidForm = false;

        if (objMensaje.item_message.messageCode === "") {
            setTxtCodeIsInValid(true);
            isInvalidForm = true;
        }

        if (objMensaje.item_message.title === "") {
            setTxtNameIsInValid(true);
            isInvalidForm = true;
        }

        if (objMensaje.item_message.body === "") {
            setTxtBodyIsInValid(true);
            isInvalidForm = true;
        }

        if (objMensaje.item_message.answerNeeded) {
            if (objMensaje.item_message.answerDeadlineDate === null) {
                setPickerAnswerDeadlineDateIsInValid(true);
                isInvalidForm = true;
            } 
        }
    

        return isInvalidForm;
    }

    const onHideActionButtons = () => {
        setHideActionButtons(true)
    }

    const setMessageItemId = (messageId) => {
        let item_message = { ...objMensaje.item_message }
        item_message.id = messageId;
        setObjMensaje(prevState => ({
            ...prevState,
            item_message: item_message
        }));

        setObjMensaje(prevState => ({
            ...prevState,
            id: messageId
        }));
    }

    const onActionMessage = (statusId) => {
        objMensaje.book_id = inputParam_BookObject.id;
        objMensaje.item_message.attacheds = documentMessageList.data !== null ? documentMessageList.data.length > 0 : false;
        objMensaje.item_message.statusId = statusId;
        objMensaje.item_message.title = inputParam_MessageObject.title
        //Solo cuando se envia, dado que quien envia podria ser un aprobador, se sobre escribe quien la envia.
        if (statusId === 4) {
            objMensaje.item_message.senderUsername = inputParam_CurrentUserName;
        }

        if (isInValidFormControl() === false) {
            if (objMensaje.id === null) {
                objMensaje.id = objMensaje.id === null ? 0 : objMensaje.id;
                objMensaje.item_message.id = objMensaje.item_message.id === null ? 0 : objMensaje.item_message.id;

                saveMessage(objMensaje).then((response) => {
                    //Supuestamente se devolverá el mismo listado pero con ids, esto hará que las opciones de "seleccionar usuario" de las cards nuevas aparezca, dado que ahora la card poseerá id.
                    //El listado retornano no posee los "name" de section y party, es por esto que se establece en null, para que vuelva a buscar los datos con los parametros indicados.
                    //Si es requerido que no se busquen nuevamente los datos, el retorno debe traer las propiedades y se deben asignar.
                    const messageId = response.data.data;
                    
                    if (documentMessageList.data !== null && documentMessageList.data.length > 0) {
                        const documentsToAdd = documentMessageList.data.filter(x => x.onTheFlyDocument === true)
                        const documents = documentMessageList.data.filter(x => x.onTheFlyDocument !== true)
    
                            
                        const aux_documentsToAdd = [];
    
                        documentsToAdd.map((document, index) => (  
                            aux_documentsToAdd.push({
                                id : 0,
                                messageId : messageId,
                                statusId : null,
                                documentId : document.id
                            })
                        ))
    
                        documents.map((document, index) => (  
                            aux_documentsToAdd.push({
                                id : 0,
                                messageId : messageId,
                                statusId : null,
                                documentId : document.id
                            })
                        ))

                        addListDocumentByMessage(messageId, aux_documentsToAdd).then((response) => {
                            setMessageItemId(messageId);
                            onHideActionButtons();
                            inputParam_SetterObjMessageList(null);
                            setShowMessage(true)
                            setMessageType("success");
                            setMessage(t('data-lang-msg-operationperformed'))
                        }).catch((ex) => {
                            setMessageItemId(messageId);

                            setShowMessage(true)
                            setMessageType("error");
                            setMessage(t('data-lang-msg-operationerror'))
                        });
                    }
                    else {
                        setMessageItemId(messageId);
                        onHideActionButtons();
                        inputParam_SetterObjMessageList(null);
                        setShowMessage(true)
                        setMessageType("success");
                        setMessage(t('data-lang-msg-operationperformed'))
                    }

                    //El recuadro vuelve a cargar la comunicación respondida, que es la seleccionada en la lista.
                    //No se le pone una copia de la respuesta: le faltan datos (visación, destinatarios propios) y
                    //competía con esta recarga; si ganaba, «Editar» mandaba la respuesta a visación sin visadores.
                    inputParam_SettFireGetMessage && inputParam_SettFireGetMessage(true);

                }).catch((ex) => {
                    setShowMessage(true)
                    setMessageType("error");
                    setMessage(t('data-lang-msg-operationerror'))
                });                
            }
            else {
                updateMessage(objMensaje).then((response) => {
                    //Supuestamente se devolverá el mismo listado pero con ids, esto hará que las opciones de "seleccionar usuario" de las cards nuevas aparezca, dado que ahora la card poseerá id.
                    //El listado retornano no posee los "name" de section y party, es por esto que se establece en null, para que vuelva a buscar los datos con los parametros indicados.
                    //Si es requerido que no se busquen nuevamente los datos, el retorno debe traer las propiedades y se deben asignar.
                    if (documentMessageList.data !== null && documentMessageList.data.length > 0) {
                        const documentsToAdd = documentMessageList.data.filter(x => x.onTheFlyDocument === true)
                        const documents = documentMessageList.data.filter(x => x.onTheFlyDocument !== true)
    
                        const aux_documentsToAdd = [];

                        const messageId = response.data.data.id;

                        documentsToAdd.map((document, index) => (  
                            aux_documentsToAdd.push({
                                id : 0,
                                messageId : messageId,
                                statusId : null,
                                documentId : document.id
                            })
                        ))
    
                        documents.map((document, index) => (  
                            aux_documentsToAdd.push({
                                id : 0,
                                messageId : messageId,
                                statusId : null,
                                documentId : document.id
                            })
                        ))
        
                        addListDocumentByMessage(messageId, aux_documentsToAdd).then((response) => {

                            setDocumentMessageList(prevState => ({
                                ...prevState,
                                fireUpdate: true,
                                data: response.data.data
                            }));

                            onHideActionButtons();

                            setShowMessage(true)
                            setMessageType("success");
                            setMessage(t('data-lang-msg-operationperformed'))
                        }).catch(() => {
                            setShowMessage(true)
                            setMessageType("error");
                            setMessage(t('data-lang-msg-operationerror'))
                        });
                    }
                    else {
                        onHideActionButtons();

                        setShowMessage(true)
                        setMessageType("success");
                        setMessage(t('data-lang-msg-operationperformed'))
                    }

                    inputParam_SettFireGetMessage && inputParam_SettFireGetMessage(true);
                }).catch(() => {
                    setShowMessage(true)
                    setMessageType("error");
                    setMessage(t('data-lang-msg-operationerror'))
                });
            }
        } else {
            setShowMessage(true)
            setMessageType("warning");
            setMessage(t('data-lang-msg-requireddatanotset'))
        }
    };

    const onClosePanel = () => {
        onDismissPanel();
    };

    const setAditionalDocumentMessageList = (modalDocumentList) => {
        let item_documentList = { ...documentMessageList.data }
        item_documentList = documentMessageList.data !== null ? joinWithoutDupes(documentMessageList.data, modalDocumentList, "id") : modalDocumentList;

        setDocumentMessageList(prevState => ({
            ...prevState,
            fireUpdate: true,
            data: item_documentList
        }));
    }

    const setMessageTitle = (value) => {
        let item_message = { ...objMensaje.item_message }
        item_message.title = (value !== null ? value : "");

        setObjMensaje(prevState => ({
            ...prevState,
            item_message: item_message
        }));
    }

    const setMessageCode = (value) => {
        let item_message = { ...objMensaje.item_message }
        item_message.messageCode = (value !== null ? value : "");

        setObjMensaje(prevState => ({
            ...prevState,
            item_message: item_message
        }));
    }

    const setMessageBody = (value) => {
        let item_message = { ...objMensaje.item_message }
        item_message.body = (value !== null ? value : "");

        setObjMensaje(prevState => ({
            ...prevState,
            item_message: item_message
        }));
    }

    const setMessageAnswerDeadlineDate = (value) => {
        let item_message = { ...objMensaje.item_message }
        item_message.answerDeadlineDate = value.toISOString();

        setObjMensaje(prevState => ({
            ...prevState,
            item_message: item_message
        }));
    }

    const onChangeRequiresAnswer = (e, checked) => {
        let item_message = { ...objMensaje.item_message }
        item_message.answerNeeded = checked;

        setObjMensaje(prevState => ({
            ...prevState,
            item_message: item_message
        }));
    };

    const onDeleteDocumentFromListClick = (item, setItemToDelete) => {
        setItemToDelete(item);
    };

    const onHideDialogAndPanel = () => {
        onDismissPanel();
        hideDialog();
    };

    const onHideDialog = (ev) => {
        ev.preventDefault();
        inputParam_SetterIsPanelOpen(true);
        hideDialog();
    };

    const onDismissPanel = () => {
        inputParam_SetterIsPanelOpen(false);
    };

    const onRenderFooterContent = () => {
        return <div className='d-flex'>
            {
            !hideActionButtons && objMensaje &&
                <>
                    <PrimaryButton
                        style={{ display: visibilityButtonSave(objMensaje !== null ? objMensaje.item_message.statusId : 0, inputParam_UserProps, inputParam_BookObject !== null ? inputParam_BookObject.requiresApproval : null) ? "none" : "block"}}
                        onClick={ () => onActionMessage(1) }
                        styles={_global_buttonStyles}>{ t('data-lang-btn-save') }</PrimaryButton>

                    <PrimaryButton
                        style={{ display: visibilityButtonCirculate(objMensaje !== null ? objMensaje.item_message.statusId : 0, inputParam_UserProps, inputParam_BookObject !== null ? inputParam_BookObject.requiresApproval : null) ? "none" : "block"}}
                        onClick={ () => onActionMessage(2) }
                        styles={_global_buttonStyles}>{ t('data-lang-btn-circulate') }</PrimaryButton>

                    <PrimaryButton
                        style={{ display: visibilityButtonSendToApprove(objMensaje !== null ? objMensaje.item_message.statusId : 0, inputParam_UserProps, inputParam_BookObject !== null ? inputParam_BookObject.requiresApproval : null) ? "none" : "block"}}
                        onClick={ () => onActionMessage(3) }
                        styles={_global_buttonStyles}>{ t('data-lang-btn-sendtoapprove') }</PrimaryButton>

                    <PrimaryButton
                        style={{ display: visibilityButtonSend(objMensaje.id, objMensaje !== null ? objMensaje.item_message.statusId : 0, inputParam_UserProps, inputParam_BookObject !== null ? inputParam_BookObject.requiresApproval : null, false) ? "none" : "block" }}
                        onClick={ () => onActionMessage(4) }
                        styles={_global_buttonStyles}>{ t('data-lang-btn-send') }</PrimaryButton>
                </>
            }
            <DefaultButton onClick={ onClosePanel }>{ t('data-lang-btn-close') }</DefaultButton>
        </div>
    };

    if (itemToDelete !== null) {
        if (objMensaje.id === null) {
            setDocumentMessageList(prevState => ({
                ...prevState,
                fireUpdate: true,
                data: documentMessageList.data.filter(x => x.id !== itemToDelete.id)
            }));

            setShowMessage(true)
            setMessageType("success");
            setMessage(t('data-lang-msg-operationperformed'))
        }
        else {
            removeDocumentByMessageDocument(itemToDelete.id, objMensaje.id).then((response) => {
                if(response.data.succeeded) {

                    setDocumentMessageList(prevState => ({
                        ...prevState,
                        fireUpdate: true,
                        data: documentMessageList.data.filter(x => x.id !== itemToDelete.id)
                    }));
        
                    setShowMessage(true)
                    setMessageType("success");
                    setMessage(t('data-lang-msg-operationperformed'))
                }
                else {
                    setShowMessage(true)
                    setMessageType("error");
                    setMessage(t('data-lang-msg-operationerror'))
                }
            }).catch(() => {
                setShowMessage(true)
                setMessageType("error");
                setMessage(t('data-lang-msg-operationerror'))
            });
        }
        setItemToDelete(null);
    }
    //Render de componente.
    return (
        <div>
            <Panel
                isOpen={ inputParam_IsPanelOpen }
                isOnRightSide={false}
                isLightDismiss={ true }
                onLightDismissClick={ showDialog }
                onDismiss={ onDismissPanel }
                headerText={ t('data-lang-lbl-responsemessage') }
                closeButtonAriaLabel={ t('data-lang-btn-close') }
                isFooterAtBottom={ true }
                onRenderFooterContent={ onRenderFooterContent }
                isBlocking={false}
                type={PanelType.customNear}
                customWidth="60vw"
                className="left-panel"
            >
                <Row className="pt-3">
                    <Col xl={6}>
                        <CTextBox editMode={ false } controlValue={ objMensaje && objMensaje.item_message.messageCode } setterControlValue={ setMessageCode } isInValid={txtCodeIsInValid} textBoxName="code" labelText={ t('data-lang-lbl-code') } />                        
                    </Col>
                </Row>
                <Row>
                    <Col className="pt-3" xs={12} sm={12} md={12} lg={12} xl={12}>
                        <CTextBox editMode={ false } controlValue={ objMensaje && inputParam_MessageObject.title } setterControlValue={ setMessageTitle } isInValid={txtNameIsInValid} textBoxName="name" labelText={ t('data-lang-lbl-title') } />
                    </Col>
                    <Col className="pt-3" xs={12} sm={12} md={12} lg={12} xl={12}>
                        <CLabel labelText={ t('data-lang-lbl-replyrecipients') } labelValue={ replyRecipients.map(r => r.name).join(', ') } />
                    </Col>
                    <Col className="pt-3" xs={12} sm={6} md={6} lg={6} xl={6}>
                        <Toggle
                            label={ t('data-lang-lbl-requiresanswer') }
                            checked={ objMensaje && objMensaje.item_message.answerNeeded }
                            onChange={ onChangeRequiresAnswer }
                            role="checkbox"
                            onText={ t('data-lang-btn-yes') }
                            offText={ t('data-lang-btn-no') }
                            styles={ {root:{float: "right", display: "flex"}, label: {marginRight : "5px"}} }
                        />
                    </Col>
                    <Col className="pt-3" xs={12} sm={6} md={6} lg={6} xl={6}>
                        <CDatePicker controlValue={ objMensaje && objMensaje.item_message.answerDeadlineDate } setterControlValue={ setMessageAnswerDeadlineDate } isInValid={ pickerAnswerDeadlineDateIsInValid } labelText={ t('data-lang-lbl-answerdeadlinedate') } />
                    </Col>
                    <Col className="pt-3" xl={12}>
                        <CTextArea
                            labelText={ t('data-lang-lbl-body') }
                            controlValue={ objMensaje && objMensaje.item_message.body }
                            setterControlValue={ setMessageBody }
                            isInvalirControl={ txtBodyIsInValid }
                            hideToolbarOptions={[
                                'link',
                                'unlink',
                                'image',
                                'remove'
                            ]}
                        />
                    </Col>
                </Row>

                <Row className="pt-3">
                    <Col className='text-end' xl={12}>
                    <ActionButton onClick={() => setIsModalDocumentOpen(true)} iconProps={{ iconName: 'OpenFile' }} allowDisabledFocus disabled={false&&documentUploadDisabled}>
                        {t('data-lang-btn-documentlilnk')}
                    </ActionButton>
                    </Col>
                    <Col xl={12}>
                        <List
                            listLocalStoragePageSizeVariableName="messageBoxResponsePanelDocuments"
                            className="no-compact-list big-header"
                            manipulateLocalData={ true }
                            setData={setDocumentMessageList}
                            data={documentMessageList}
                            columns={[
                                {  
                                    key: 'extension',
                                    name: t('data-lang-lbl-type'),
                                    fieldName: 'extension',
                                    minWidth: 40,
                                    maxWidth: 40,
                                    onRender:(item) => {
                                        return getKeyByValue(__DocumentTypeKeys, item.extension)
                                    }
                                },
                                {
                                    key: "documentCode",
                                    name: t('data-lang-lbl-code'),
                                    fieldName: "documentCode",
                                    minWidth: 50,
                                    maxWidth: 100,
                                    isResizable: true
                                },
                                {
                                    key: "name",
                                    name: t('data-lang-lbl-name'),
                                    fieldName: "name",
                                    minWidth: 100,
                                    maxWidth: 200,
                                    isResizable: true
                                },
                                {
                                    key: "modificationUsername",
                                    name: t('data-lang-lbl-modificationusername'),
                                    fieldName: "modificationUsername",
                                    minWidth: 100,
                                    maxWidth: 100,
                                    isResizable: true
                                },
                                {
                                    key: "creationUsername",
                                    name: t('data-lang-lbl-creationusername'),
                                    fieldName: "creationUsername",
                                    minWidth: 100,
                                    maxWidth: 100,
                                    isResizable: true
                                },
                                {  
                                    key: 'id',
                                    name: t('data-lang-lbl-actions'),
                                    fieldName: 'id',
                                    //minWidth: "10%",
                                    //maxWidth: "10%",
                                    onRender:(item, row) => {
                                        return <div>
                                                <OverflowSet
                                                    className="action-menu-list-toolbar d-flex justify-content-center list-menu-action"
                                                    role="menubar"
                                                    items={[
                                                        {
                                                            key: 'item1',
                                                            icon: 'Delete',
                                                            name: t('data-lang-btn-delete'),
                                                            title: t('data-lang-btn-delete'),
                                                            onClick: () => onDeleteDocumentFromListClick(item, setItemToDelete),
                                                        }
                                                    ]}
                                                    onRenderOverflowButton={__onRenderOverflowButton}
                                                    onRenderItem={__onRenderOverflowItem}
                                                />
                                        </div>
                                    }
                                }  
                            ]}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col className="message-verybottom-panel-medium-pagination">
                        <ListPagination
                            listLocalStoragePageSizeVariableName="messageBoxResponsePanelDocuments"
                            data={ documentMessageList }
                            setData={ setDocumentMessageList } />
                    </Col>
                </Row>
                <Row>
                    <Col className="message-verybottom-panel-medium-message">
                        <Message message={ message } display={ showMessage === null? false : showMessage } messageType={messageType} setterShowMessage={ setShowMessage } />
                    </Col>
                </Row>
                <DocumentLinkModal
                    bookObject={inputParam_BookObject}
                    isModalOpen={ isModalDocumentOpen }
                    setIsModalOpen={setIsModalDocumentOpen}
                    setterSelectedDocumentToLink={ setAditionalDocumentMessageList }
                    userProps={inputParam_UserProps}
                />
                <Dialog
                    hidden={!isDialogVisible}
                    onDismiss={onHideDialog}
                    dialogContentProps={{
                        type: DialogType.normal,
                        title: t('data-lang-msg-close-panel'),
                    }}
                    modalProps={{
                        isBlocking: true,
                        styles: { main: { maxWidth: 450 } },
                    }}
                    >
                    <DialogFooter>
                        <PrimaryButton onClick={onHideDialogAndPanel} text={t('data-lang-lbl-yes')} />
                        <DefaultButton onClick={onHideDialog} text={t('data-lang-lbl-no')} />
                    </DialogFooter>
                </Dialog>
            </Panel>
        </div>
    );
}

export default SidePanelResponse;